import { createSlice } from "@reduxjs/toolkit";

export const location = createSlice({
  name: "locationTabs",
  initialState: {
    activeTabs: "location",
  },

  reducers: {
    updateCurrentLocationTabs: (state = location?.initialState, action) => {
      state.activeTabs = action.payload;
    },
  },
});
export const { updateCurrentLocationTabs } = location.actions;
export default location.reducer;
